import { render, staticRenderFns } from "./AiBookCover.vue?vue&type=template&id=c3f9f4a4&scoped=true"
import script from "./AiBookCover.vue?vue&type=script&lang=js"
export * from "./AiBookCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f9f4a4",
  null
  
)

export default component.exports